<style lang='scss'>
.lookitem {
  line-height: 32px;

  .item-label {
    float: left;
    width: 100px;
    text-align: right;
    margin-bottom: 16px;
    padding-right: 16px;
  }

  .item-content {
    float: left;
    margin-bottom: 16px;
  }
}
</style>

<template>
    <div class="clearfix">
        <Breadcrumb class="tablelist-header">
            <BreadcrumbItem>{{type==='edit'?$t('global.common.edit',{defaultValue:'编辑'}):$t('erp.product.new_add',{defaultValue:'添加'})}}虚拟调拨</BreadcrumbItem>
        </Breadcrumb>
        <Alert class="padding-10">
            <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
		</Alert>
        <div class="bg-fff  shadow padding-bottom-15 lookitem">
            <header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
            <vForm :label-width="120" class="clearfix padding-15" ref="form" :model="formData">
                <vCol span='12'>
                    <vFormItem :label="$t('erp.virtualstore.transferordernum',{defaultValue:'调拨单号'})">
                        <p>{{formData.transferNo}}</p>
                    </vFormItem>
                </vCol>
                <vCol span='12'>
                    <vFormItem :label="$t('global.common.status',{defaultValue:'状态'})">
                        <p>{{$t('fbb.alloment.draft',{defaultValue:'草稿'})}}</p>
                    </vFormItem>
                </vCol>
                <vCol span='12'>
                    <vFormItem prop="outWarehouseId" :key="formData.orgWarehouseId" :rules="required" label='虚拟出库仓'>
                        <Input :value="formData.outWarehouseId | transferText('ruleName',outVsrule)" readonly placeholder="请选择">
                            <Button slot="append" @click="showVirtualbox">搜索</Button>
                        </Input>
                    </vFormItem>
                </vCol>
                <vCol span='12'>
                    <vFormItem prop="lineId" :rules="required" :label="$t('erp.virtualstore.subordinateproject',{defaultValue:'所属项目'})">
                        <p>{{(transferText(formData.lineId, 'name',products)) || '--'}}</p>
                    </vFormItem>
                </vCol>
                <vCol span='12'>
                    <vFormItem prop="orgWarehouseId" :rules="required" :label="$t('erp.virtualstore.actualoutwarehouse',{defaultValue:'实际出库仓库'})">
                        <p v-if="formData.orgWarehouseId">{{ formData.orgWarehouseId | transferText('title',warehouses) }} ({{ formData.orgWarehouseId | transferText('code',warehouses) }})</p>
                        <span v-else>--</span>
                    </vFormItem>
                </vCol>
                
                <vCol span='12'>
                <vFormItem prop="inWarehouseId" :key="formData.orgWarehouseId" :rules="required" :label="$t('erp.virtualstore.virtualinware',{defaultValue:'虚拟入库仓'})">
                    <Select
                        v-model="formData.inWarehouseId"
                        filterable
                        ref="inwareselect"
                        clearable
                        >
                        <Option v-for="item in inVsrule" :value="item.id" :key="item.id">{{ item.ruleName }}</Option>
                    </Select>
                </vFormItem>
                </vCol>
                <vCol span='24'>
                <vFormItem :label="$t('global.common.reason',{defaultValue:'原因'})">
                    <Input v-model="formData.description" type="textarea" :rows="4"/>
                </vFormItem>
                </vCol>
                <vCol span='12'>
                <vFormItem label='ERPSKU'>
                    <Select clearable v-model="erpSku" @on-change="getStockQuantity" filterable ref="erpselect">
                        <Option v-for="item in erpSkusList" :value="item.name" :key="item.id">{{ item.name }}</Option>
                    </Select>
                    <!-- <Input v-model="formData.erpSku" type="textarea" /> -->
                </vFormItem>
                <!-- 仓库可用总库存量:
                    虚拟仓可用总仓库量: -->
                </vCol>
                <vCol span='12'>
                <vFormItem :label="$t('fbb.alloment.out_bound_number',{defaultValue:'出库数量'})" class="pull-left">
                    <InputNumber v-model="quantity" :min="0"/>
                    <Button type="primary" @click="hanldeItem">{{$t('erp.product.new_add',{defaultValue:'添加'})}}</Button>
                    <div v-for="(item,index) in totals" :class="{'color-error':index==0}" :key="index" v-show="quantityOutShow">
                        {{$t('erp.virtualstore.virtualoutware',{defaultValue:'虚拟出库仓'})}}:{{item.ruleName||0}};&nbsp;&nbsp;
                        {{$t('erp.virtualstore.wareavaliablestock',{defaultValue:'仓库可用库存'})}}:{{item.actualNum||0}};&nbsp;&nbsp;
                        {{$t('erp.virtualstore.virtualwareavaliaware',{defaultValue:'虚拟仓可用仓库'})}}:{{item.virtualNum||0}}
                        <!-- 添加虚拟出库仓量： -->
                    </div>
                </vFormItem>
                </vCol>
            </vForm>
            <Table
                :columns="columns"
                :data="erpSkusData"
                size="small"
                ref="table"
                class="margin-left-15 margin-right-15 margin-bottom-15"
                border
                stripe></Table>
            <footer class="text-center margin-top-15">
                <Button type="primary" @click="submit" class="width-15per">{{$t('global.common.save',{defaultValue:'保存'})}}</Button>
                <Button class="margin-left-10 width-15per" @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</Button>
            </footer>
            <!-- 虚拟仓 -->
            <Modal
                width="1000"
                :title="$t('erp.virtualstore.searchvirtualoutware',{defaultValue:'搜索虚拟出库仓'})"
                @on-cancel="showVirtualcacel"
                @on-ok="setOutGroupRule"
                v-model="showVirtual">
                <compVirtualalert ref="vsdata" 
                :virtlineId="formData.lineId" 
                :virtorgWarehouseId="formData.orgWarehouseId"
                :virterpSku="erpSku"
                :virtalertsearch="virtalertsearch"
                />
            </Modal>
            <Spin size="large" fix v-if="loading"></Spin>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex'
import {
    HttpVsAllot,
    HttpUpdateVsAllot,
    HttpVsAllotNo,
    HttpVsRuleList,
    HttpVsQuantity,
    HttpGroupRuleAlert,
    HttpProductByLineId
} from '@/service/boss/allot';
import { Button } from 'view-design';
import compVirtualalert from './virtualalert'

export default {
    components: {
		compVirtualalert
	},
    data() {
        return {
            id: this.$route.query.id,
            type: this.$route.params.type,
            erpSkusData: [],
            loading: false,
            quantityOutShow: false,
            outVsrule: [],
            inVsrule: [],
            erpSkusList: [],
            erpSku: '',
            quantity: 0,
            totals: [],
            formData: {
                orgId: global.SYSID,
                transferNo: '',
                lineId: '',
                orgWarehouseId: '',
                outWarehouseId: '',
                inWarehouseId: '',
                description: '',
                status: 'DRAFT',
            },
            required: [{
                required: true,
                message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'})
            }],
            // 新增弹框的变量
            showVirtual:false,
            virtalertsearch:false,
            ruleDatas:[],
            // showfilterAble:false,
        };
    },
    created() {
        if (this.type === 'edit') {
            this.getDetail()
            
        } else {
            this.getTransferNo();
        }
    },
    methods: {
        transferText(val, textKey, list = [], key = "id") {
            let text = "";
            list.forEach(item => {
                if (item[key] === val) {
                    text = item[textKey]
                }
            });
            return text;
        },
        cancel() {
            this.$router.push({ name: "vsAllot" })
        },
        hanldeItem() {
            const erpSku = this.erpSku, quantity = this.quantity;
            if (erpSku && quantity) {
                const iscompat = this.erpSkusData.some((item) => {
                    const bool = erpSku === item.erpSku;
                    if (bool) {
                        item.quantity += quantity;
                    }
                    return bool;
                })
                if (!iscompat) {
                    this.erpSkusData.push({
                        quantity,
                        erpSku: erpSku,
                        useQuantity: (this.totals[0]||{}).virtualNum
                    });
                }
                this.quantity = this.erpSku = "";
            } else {
                this.$Message.error(this.$t('erp.virtualstore.fillskuandoutnumber',{defaultValue:'请填写erpSku和出库数量'}));
            }
        },
        removeData(index) {
            this.erpSkusData.splice(index, 1);
        },
        async getStockQuantity(value) {
            if (!value) return;
            this.quantityOutShow = false;
            this.erpSku = value;
            this.$set(this.$data,"erpSku",value)
            HttpVsQuantity({
                orgWarehouseId: this.formData.orgWarehouseId,
                outWarehouseId: this.formData.outWarehouseId,
                erpSku: value,
            }).then(res => {
                const data = res.data || []
                const index = data.findIndex((item, index) => {
                    return this.outVsrule.some((val ) => {
                        return item.ruleName == val.ruleName
                    })
                })
                if(index>-1)  data.unshift(data.splice(index, 1)[0])
                this.quantityOutShow = true;
                this.totals = data;
            }, err => {
                this.errorMessage(err.message);
            });
        },
        async getTransferNo() {
            HttpVsAllotNo().then(res => {
                this.formData.transferNo = res.data;
            });

        },
        async getProductList(lineId) {
            this.quantity = "";
            HttpProductByLineId({ lineId }).then(res => {
                this.erpSkusList = res.data.map((item) => {
                    return { name: item.erpSku, id: item.id }
                });
            });
        },
        getInGroupRule(query) {
            this.getVsGroupRule(query, 'inVsrule', '');
        },
        getOutGroupRule(query) {
            this.getVsGroupRule(query, 'outVsrule', '');
        },
        handleResponse(data = {}) {
            // console.log(data)
            const { transferNo, lineId, id, orgWarehouseId, inWarehouseId, outWarehouseId, description, status, orgId = global.SYSID } = data;
            this.formData = {
                lineId, orgWarehouseId
            };
            this.getProductList(lineId);
            setTimeout(() => {
                this.formData = {
                    transferNo,
                    lineId,
                    orgWarehouseId,
                    inWarehouseId,
                    outWarehouseId,
                    description,
                    status,
                    orgId,
                    id
                };
                this.erpSkusData = data.stockTransferItems || [];
            }, 300);
            this.getVsGroupRule("", "all");
            // console.log(this.formData)
        },
        async getDetail() {
            this.loading = true;
            HttpVsAllot({ id: this.id }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.errorMessage(err.message);
                this.loading = false;
            });
        },
        async getVsGroupRule(query = "", key, erpsku,stockGroupId) {
            const response = await HttpGroupRuleAlert({
                page: 1,
                rows: 50,
                sidx: 'id',
                sord: 'desc',
                lineId:this.formData.lineId,
                orgWarehouseId:this.formData.orgWarehouseId,
                name:query,
                erpSku:erpsku,
                stockGroupId:stockGroupId,
            });
            if (response) {
                if (key === 'all') {
                    this.ruleDatas = this['inVsrule'] = this["outVsrule"] = response.data.content;
                } else if(key === 'outVsrule'){
                    this[key] = response.data.content;
                    // this['inVsrule'] = this.ruleDatas;
                }
                else {
                    this['inVsrule'] = response.data.content;
                }
            }
        },
        handleRequest() {
            let erpSkus = this.erpSkusData.map(item => {
                return item.erpSku;
            }), quantity = this.erpSkusData.map(item => {
                return item.quantity;
            });
            return {
                ...this.formData, orgId: global.SYSID, items: this.erpSkusData.map(item => {
                    return {
                        id: item.id,
                        erpSku: item.erpSku,
                        quantity: item.quantity
                    }
                })
            }
        },
        // 弹框里面的确定按钮
        setOutGroupRule(){
            this.formData.inWarehouseId='';
            // 清空入库仓和erpsku的值
            this.$refs.erpselect.clearSingleSelect();
            this.$refs.inwareselect.clearSingleSelect();
            const row = this.$refs.vsdata.getRowData();
            // console.log(row)
            if(!row.orgId) return ;
            this.formData = Object.assign(this.formData, { lineId: row.lineId, erpSku: row.erpSku, orgWarehouseId: row.orgWarehouseId, outWarehouseId: row.id})
            this.erpSkusData = [];
            if(row.erpSku){
                // console.log(12345)
                this.erpSkusList = [];
                const erpskudata = {
                    name: row.erpSku,
                    id:new Date().getTime()
                }
                this.erpSkusList.push(erpskudata)
                this.$set(this.erpSkusList,0,erpskudata)
                // 请求虚拟仓入库列表
                this.getVsGroupRule('', 'inVsrule', row.erpSku, row.stockGroupId)
            }else{
                this.getProductList(this.formData.lineId);
                // 请求虚拟仓入库列表
                this.getVsGroupRule('', 'inVsrule', '', row.stockGroupId)
            }
            this.virtalertsearch = false;
            this.getOutGroupRule(row.ruleName)
        },
        showVirtualbox(){
            this.showVirtual = true;
            this.virtalertsearch = true;
        },
        showVirtualcacel(){
            this.formData.lineId = '';
            this.formData.orgWarehouseId = '';
            this.showVirtual = false;
            this.virtalertsearch = false;
        },
        async submit() {
            let valid = await this.$refs['form'].validate();
            if (!valid) return;
            if (this.erpSkusData.length <= 0) {
                this.$Message.warning(this.$t('erp.virtualstore.addtransferdata',{defaultValue:'请添加调拨数据'}));
                return;
            }
            this.loading = true;
            HttpUpdateVsAllot(this.handleRequest()).then(res => {
                this.$Message.success(res.message);
                this.cancel();
                this.loading = false;
            }, err => {
                this.errorMessage(err.message);
                this.loading = false;
            });
        }
    },
    computed: {
        ...mapState('boss',['products']),
        ...mapGetters('boss',['warehouses']),
        columns() {
            return [
                {
                    title: 'ID',
                    key: 'id',
                }, {
                    title: 'ERPSKU',
                    key: 'erpSku',
                },
                {
                    title: this.$t('erp.virtualstore.virtualwareavaliainventory',{defaultValue:'虚拟仓可用库存'}),
                    key: 'useQuantity',
                },
                {
                    title: this.$t('fbb.alloment.out_bound_number',{defaultValue:'出库数量'}),
                    key: 'quantity',

                },
                {
                    title: this.$t('global.common.operate',{defaultValue:'操作'}),
                    render: (h, { index }) => {
                        return <Button type="error" size="small" nativeOnClick={this.removeData.bind(this, index)}> {this.$t('global.common.delete',{defaultValue:'删除'})} </Button>
                    }
                }];
        },
    },
};
</script>



